import axios from "axios";

export const getDiscordEvents = () => axios.get("/api/discord/events").then((r) => r.data.events);
